import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  List: [],
  externalResource: {},
  profile_number_external: "",
  resourceStatusList: [],
  resourcePosition: [],
  menuePermission: [],
  contactExternalResource: [],
  propertyExternalResource: [],
  edit_external_resource_data:[],
  new_external_created:[],
  searched_criteria_dropdown:[],
  external_payment_data:[],
  payment_bank_detail:[],
  resource_review:[],
  external_user_jobs_dropdown:[],
  resource_assets:[],
  job_score_review_list:[],
  profileChangeRequestsList: [],
  propertyList_dropdown:[],
};

const externalResourceSlice = createSlice({
  name: "externalResourceSlice",
  initialState,
  reducers: {
    setExternalResource: (state, action) => ({
      ...state,
      List: action.payload,
    }),
    setSingleExternalResource: (state, action) => ({
      ...state,
      externalResource: action.payload,
    }),
    setUserPaymentData: (state, action) => ({
      ...state,
      payment_bank_detail: action.payload,
    }),
    setProfileNumber: (state, action) => ({
      ...state,
      profile_number_external: action.payload,
    }),
    setResourceStatusList: (state, action) => ({
      ...state,
      resourceStatusList: action.payload,
    }),
    setResourcePositionList: (state, action) => ({
      ...state,
      resourcePosition: action.payload,
    }),
    setTreeMenueList: (state, action) => ({
      ...state,
      menuePermission: action.payload,
    }),
    setContactExternalResource: (state, action) => ({
      ...state,
      contactExternalResource: action.payload,
    }),
    setPropertyExternalResource: (state, action) => ({
      ...state,
      propertyExternalResource: action.payload,
    }),
    setEditExternalResource: (state, action) => ({
      ...state,
      edit_external_resource_data: action.payload,
    }),
    saveNewExternalData: (state, action) => ({
      ...state,
      new_external_created: action.payload,
    }),
    setsearchCriteria: (state, action) => ({
      ...state,
      searched_criteria_dropdown: action.payload,
    }),
    getUserPaymentData: (state, action) => ({
      ...state,
      external_payment_data: action.payload,
    }),
    getResourceAssets: (state, action) => ({
      ...state,
      resource_review: action.payload,
    }),
    setExternalUserJobs: (state, action) => ({
      ...state,
      external_user_jobs_dropdown: action.payload,
    }),
    getResourceAssetsByIuserId: (state, action) => ({
      ...state,
      resource_assets: action.payload,
    }),
    setJobScoreReview: (state, action) => ({
      ...state,
      job_score_review_list: action.payload,
    }),
    setProfileChangeRequestsList: (state, action) => ({
      ...state,
      profileChangeRequestsList: action.payload,
    }),
    setPropertyListDropdown: (state, action) => ({
      ...state,
      propertyList_dropdown: action.payload,
    }),
  },
});

export const {
  setExternalResource,
  setSingleExternalResource,
  setUserPaymentData,
  setProfileNumber,
  setResourceStatusList,
  setResourcePositionList,
  setTreeMenueList,
  setContactExternalResource,
  setPropertyExternalResource,
  setEditExternalResource,
  saveNewExternalData,
  setsearchCriteria,
  getUserPaymentData,
  getResourceAssets,
  setExternalUserJobs,
  getResourceAssetsByIuserId,
  setJobScoreReview,
  setProfileChangeRequestsList,
  setPropertyListDropdown
} = externalResourceSlice.actions;

export default externalResourceSlice.reducer;
